import { useTheme } from 'styled-components';

import { CustomSvg, SvgIconDefaultProps } from '@libs/components';

const DepositIconGe: React.FC<SvgIconDefaultProps> = ({
  className,
  testId = 'depositIcon',
  color,
}) => {
  const { colors } = useTheme();
  const iconColor = color ? color : colors.interactive.brandColor;

  return (
    <CustomSvg
      className={className}
      data-cy={testId}
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        d="M2.2627 16.04C2.2627 16.6025 2.49789 17.144 2.93164 17.5415C3.33414 17.9115 3.8802 18.125 4.4502 18.125L16.9502 18.125C17.5202 18.125 18.0662 17.9115 18.4688 17.5415C18.9025 17.144 19.1377 16.6025 19.1377 16.04L19.1377 4.58496C19.1377 4.02246 18.9025 3.481 18.4688 3.0835C18.0663 2.7135 17.5202 2.5 16.9502 2.5L15.7002 2.5C15.1827 2.5 14.7627 2.92 14.7627 3.4375C14.7627 3.955 15.1827 4.375 15.7002 4.375L16.9502 4.375C17.0439 4.375 17.1342 4.40289 17.1992 4.46289C17.2355 4.49539 17.2627 4.53871 17.2627 4.58496L17.2627 16.04C17.2627 16.0863 17.2355 16.1296 17.1992 16.1621C17.1342 16.2221 17.0439 16.25 16.9502 16.25L4.4502 16.25C4.35645 16.25 4.26617 16.2221 4.20117 16.1621C4.16492 16.1296 4.1377 16.0863 4.1377 16.04L4.1377 4.58496C4.1377 4.53871 4.16492 4.49539 4.20117 4.46289C4.26617 4.40289 4.35645 4.375 4.4502 4.375L5.7002 4.375C6.2177 4.375 6.6377 3.955 6.6377 3.4375C6.6377 2.92 6.2177 2.5 5.7002 2.5L4.4502 2.5C3.8802 2.5 3.33414 2.7135 2.93164 3.0835C2.49789 3.481 2.2627 4.02246 2.2627 4.58496L2.2627 16.04ZM7.2627 9.0625C7.2627 9.3025 7.35545 9.54162 7.53857 9.72412L10.0386 12.2241C10.4048 12.5904 10.9956 12.5904 11.3618 12.2241L13.8618 9.72412C14.2281 9.35912 14.2281 8.76588 13.8618 8.40088C13.4968 8.03463 12.9036 8.03463 12.5386 8.40088L11.6377 9.30176L11.6377 2.8125C11.6377 2.295 11.2177 1.875 10.7002 1.875C10.1827 1.875 9.7627 2.295 9.7627 2.8125L9.7627 9.30176L8.86182 8.40088C8.49682 8.03463 7.90357 8.03463 7.53857 8.40088C7.35545 8.58338 7.2627 8.8225 7.2627 9.0625Z"
        fill={iconColor}
      />
    </CustomSvg>
  );
};
export default DepositIconGe;
